import { AppShell, AppShellMain } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ClientOnly } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { Header } from '@/layouts/Header'
import { Footer } from '@/layouts/Footer'
import GtmProvider from '@/layouts/GtmProvider.tsx'

export const AppLayout = ({
	children,
}: Readonly<{
	children: ReactNode
}>) => {
	return (
		<AppShell layout={'default'}>
			<ClientOnly>
				<GtmProvider />
			</ClientOnly>
			<Notifications />
			<AppShellMain>
				<Header />
				{children}
				<Footer />
			</AppShellMain>
		</AppShell>
	)
}
